import React from 'react';
import Marketing from '../images/marketing.svg';
import { Link } from 'react-router-dom';
import { FaCloud, FaLock, FaMobileAlt, FaDesktop } from 'react-icons/fa';
import SubserviceDetailComponent from '../components/SubserviceDetailComponent';

const services = [
  {
    icon: <FaCloud />,
    title: 'Print Advertising',
    description: 'Reach your audience with effective print advertising. Our services include designing and placing ads in newspapers, magazines, and other print media.',
  },
  {
    icon: <FaLock />,
    title: 'Direct Mail Campaign',
    description: 'Target your audience with personalized direct mail campaigns. We design and distribute mailers that drive responses and increase brand awareness.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Outdoor Advertising',
    description: 'Capture attention with impactful outdoor advertising. Our solutions include billboards, transit ads, and other high-visibility placements to enhance brand exposure.',
  },
  {
    icon: <FaDesktop />,
    title: 'Business Cards',
    description: 'Make a strong impression with custom-designed business cards. Our high-quality cards reflect your brand’s professionalism and leave a lasting impression on contacts.',
  },
  {
    icon: <FaDesktop />,
    title: 'Brand Stationary',
    description: 'Establish a cohesive brand identity with custom stationery. We design letterheads, envelopes, and other office materials that reinforce your brand’s image.',
  },
  {
    icon: <FaDesktop />,
    title: 'Company Profile',
    description: 'Showcase your business with a professional company profile. We create detailed profiles that highlight your services, achievements, and values to potential clients',
  },
];

const TraditionalMarket = () => {
  return (
    <div className = "relative">
      <img
        className="h-auto w-full object-cover"
        src={Marketing}
        alt="Marketing Services"
      />

      <div>

      <section className='text-left mt-6'>
      <h1 className="text-center my-6 text-2xl font-semibold">Traditional Marketing</h1>
      </section>
     

      <section>
        <SubserviceDetailComponent services={services}/>
        <div className='mb-6'>
        <h2 className="text-xl font-semibold mb-6 mx-6">Get Started with Expert Marketing Services</h2>
        <p className="text-md text-black mb-6 px-12 text-left">
        Maximize efficiency, enhance security, and drive growth with our tailored Marketing Services. Our certified experts provide 24/7 support, proactive monitoring, and strategic Marketing planning to meet your business needs.
        </p>
        
        <Link to="/contact"
        className="inline-block bg-[#13689b] text-white py-3 px-6 rounded-md text-md font-semibold transition-transform transform hover:scale-105">
      Contact Us
      </Link>
        </div>
      </section>

    </div>

    </div>
  )
}

export default TraditionalMarket
